import { render, staticRenderFns } from "./SparklineGraph.vue?vue&type=template&id=4c156c78&"
import script from "./SparklineGraph.vue?vue&type=script&lang=js&"
export * from "./SparklineGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSparkline } from 'vuetify/lib/components/VSparkline';
installComponents(component, {VSparkline})
